import type { MetalCode } from '@/graphql/api'
import { assertNever } from '@/helpers'

export function getClassMetalVariation(metalCode: MetalCode): string {
    switch (metalCode) {
        case 'EIGHTEEN_KARAT_ROSE_GOLD':
            return 'eighteen rose-gold'

        case 'FOURTEEN_KARAT_ROSE_GOLD':
            return 'fourteen rose-gold'

        case 'NINE_KARAT_ROSE_GOLD':
            return 'nine rose-gold'

        case 'EIGHTEEN_KARAT_YELLOW_GOLD':
            return 'eighteen yellow-gold'

        case 'FOURTEEN_KARAT_YELLOW_GOLD':
            return 'fourteen yellow-gold'

        case 'NINE_KARAT_YELLOW_GOLD':
            return 'nine yellow-gold'

        case 'EIGHTEEN_KARAT_WHITE_GOLD':
            return 'eighteen white-gold'

        case 'FOURTEEN_KARAT_WHITE_GOLD':
            return 'fourteen white-gold'

        case 'NINE_KARAT_WHITE_GOLD':
            return 'nine white-gold'

        case 'PLATINUM':
            return 'platinum'

        case 'SILVER':
            return 'silver'

        default:
            return assertNever(metalCode, '')
    }
}

export function getVariationMetalAbbreviation(metalCode: MetalCode): string {
    switch (metalCode) {
        case 'EIGHTEEN_KARAT_ROSE_GOLD':
        case 'EIGHTEEN_KARAT_YELLOW_GOLD':
        case 'EIGHTEEN_KARAT_WHITE_GOLD':
            return '18'

        case 'FOURTEEN_KARAT_ROSE_GOLD':
        case 'FOURTEEN_KARAT_YELLOW_GOLD':
        case 'FOURTEEN_KARAT_WHITE_GOLD':
            return '14'

        case 'NINE_KARAT_ROSE_GOLD':
        case 'NINE_KARAT_YELLOW_GOLD':
        case 'NINE_KARAT_WHITE_GOLD':
            return '9'

        case 'PLATINUM':
            return 'PT'

        case 'SILVER':
            return 'SV'

        default:
            return assertNever(metalCode, '')
    }
}
